import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Navbar from "@/components/Navbar";
import MusicPlayer from "@/components/MusicPlayer";
import Landing from "@/pages/Landing";
import Auth from "@/pages/Auth";
import About from "@/pages/About";
import Search from "@/pages/Search";
import ProviderProfile from "@/pages/ProviderProfile";
import Dashboard from "@/pages/Dashboard";
import PaymentReturn from "@/pages/PaymentReturn";
import VerifyCaregiver from "@/pages/VerifyCaregiver";
import SharedReview from "@/pages/SharedReview";
import ResetPassword from "@/pages/ResetPassword";
import Reschedule from "@/pages/Reschedule";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="p-20 text-center font-heading">Loading…</div>;
  if (!user) return <Navigate to="/auth" replace />;
  return children;
}

function Shell() {
  return (
    <>
      <Navbar />
      <MusicPlayer />
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/auth" element={<Auth />} />
        <Route path="/about" element={<About />} />
        <Route path="/search" element={<Search />} />
        <Route path="/provider/:id" element={<ProviderProfile />} />
        <Route path="/dashboard" element={<Protected><Dashboard /></Protected>} />
        <Route path="/payment-return" element={<PaymentReturn />} />
        <Route path="/verify-caregiver" element={<VerifyCaregiver />} />
        <Route path="/review/:slug" element={<SharedReview />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/reschedule/:token" element={<Reschedule />} />
      </Routes>
    </>
  );
}

export default function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Shell />
          <Toaster richColors position="top-center" />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}
